import React, { useCallback, useEffect, useState } from "react";
import {
  Modal,
  Button,
  Text,
  Input,
  Dropdown,
  Switch,
  Loading,
} from "@nextui-org/react";
import { makeFetch } from "../../service/makeFetch";
import { useNotifications } from "reapop";
import useStorage from "../storage/useLocalStorage";

export default function AddUser({
  children,
  makeVisible = false,
  setVisible = () => null,
  isAdmin = false,
  style = {},
}) {
  const { notify } = useNotifications();
  const [selectedRole, setSelected] = React.useState(["Developer"]);
  const [newHandle, setNewHandle] = React.useState("");
  const [newEmail, setNewEmail] = React.useState("");
  const [isActive, setIsActive] = React.useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const [refreshAccount = false, setRefreshAccount] =
    useStorage("refreshAccount");

  const selectedRoleValue = React.useMemo(
    () => Array.from(selectedRole).join(", ").replaceAll("_", " "),
    [selectedRole]
  );

  const closeHandler = () => {
    setVisible(false);
    setNewHandle("");
    setNewEmail("");
    console.log("closed");
  };

  const onHandleChange = useCallback((e) => {
    setNewHandle(e.target.value);
  }, []);

  const onEmailChange = useCallback((e) => {
    setNewEmail(e.target.value);
  }, []);

  const onHandleChangeActive = useCallback(
    (e) => {
      setIsActive(!isActive);
    },
    [isActive]
  );

  const createAccount = useCallback(async () => {
    if (isUpdating === true) return;
    setIsUpdating(true);
    const obj = {
      handle: newHandle,
      idType: "developer",
      email: newEmail,
      authActionCreateAccountKey: "r7TzL1qA9sG3pW6_creation_account_2024",
    };
    const result = await makeFetch({
      url: "account/create",
      method: "POST",
      body: obj,
    });
    setIsUpdating(false);
    if (result === undefined || result === null) {
      notify("Error getting data failed!", "error");
      return;
    }
    if (result?.error === true) {
      notify(result.message, "error");
      return;
    } else {
      notify("User updated!", "success");
      setRefreshAccount(true);
      closeHandler();
    }
    if (typeof window !== "undefined") {
      // setData(result);
    }
  }, [selectedRoleValue, newHandle, isActive, isUpdating, newEmail]);

  return (
    <div style={style}>
      {children}
      <Modal
        closeButton
        blur
        aria-labelledby="modal-title"
        open={makeVisible}
        onClose={closeHandler}
        width="400px"
      >
        <Modal.Header>
          <Text id="modal-title" size={18} b>
            Add User
          </Text>
        </Modal.Header>
        <Modal.Body>
          <>
            <Input
              value={newHandle}
              label="Full Name"
              placeholder={"Add name"}
              onChange={onHandleChange}
            />
            <Input
              value={newEmail}
              label="Email"
              placeholder={"Add email"}
              onChange={onEmailChange}
            />
            {isAdmin === true && (
              <>
                <Text>Role</Text>
                <Dropdown>
                  <Dropdown.Button
                    flat
                    color="secondary"
                    css={{ tt: "capitalize" }}
                  >
                    {selectedRoleValue}
                  </Dropdown.Button>
                  <Dropdown.Menu
                    aria-label="Single selection actions"
                    color="secondary"
                    disallowEmptySelection
                    selectionMode="single"
                    selectedKeys={selectedRole}
                    onSelectionChange={setSelected}
                  >
                    <Dropdown.Item key="developer">Developer</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                {/* <Text>Active</Text>
                <Switch checked={isActive} onChange={onHandleChangeActive} /> */}
              </>
            )}
          </>
        </Modal.Body>
        <Modal.Footer>
          <Button auto flat color="error" onPress={closeHandler}>
            Close
          </Button>
          <Button auto onPress={createAccount}>
            {isUpdating === true ? (
              <Loading size="sm" color={"white"} />
            ) : (
              "Create"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
